
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/basics/variants-and-density",
      function () {
        return require("private-next-pages/x/react-chat/basics/variants-and-density.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/basics/variants-and-density"])
      });
    }
  